import React, { useState, useEffect } from 'react';
import '../../src/Slider.css';

const slideData = [
  {
    id: 1,
    title: "Kumpulkan stamp, tukar dengan rewards menarik!",
    description: "Dengan aplikasi Summarecon Mall, kamu bisa kumpulkan Stamps setiap kali belanja di Summarecon Mall",
    bgColor: '#DB4726',
    phoneMockup: process.env.PUBLIC_URL+'/assets/img/slider/slide-mall.png', 
    appStoreUrl: "https://apps.apple.com/id/app/summarecon-mall/id1564420394",
    playStoreUrl: "https://play.google.com/store/apps/details?id=com.summareconmall"
  },
  {
    id: 2,
    title: "Dapatkan Banyak fasilitas tambahan untuk properti Summarecon",
    description: "Anti ribet! lakukan semua aktifitas Town Management di lingkungan Summarecon lewat satu aplikasi",
    bgColor: "#085D3A",
    phoneMockup: process.env.PUBLIC_URL+'/assets/img/slider/slide-home.png',
    appStoreUrl: "https://apps.apple.com/id/app/summarecon-home/id1584050086",
    playStoreUrl: "https://play.google.com/store/apps/details?id=com.summareconhome"
  },
  {
    id: 3,
    title: "Aktifitas perkuliahan jadi lebih mudah dengan Pradita Apps",
    description: "Dari cek jadwal kuliah, pembayaran sampai lihat aktifitas kegiatan kampus semua di Pradita Apps",
    bgColor: "#F36F21",
    phoneMockup: process.env.PUBLIC_URL+'/assets/img/slider/slide-pradita.png',
    appStoreUrl: "https://apps.apple.com/id/app/pradita-university/id6740115065",
    playStoreUrl: "https://play.google.com/store/apps/details?id=com.praditauniversity"
  },
  {
    id: 4,
    title: "Olahraga kini lebih tenang & menyenangkan",
    description: "Lihat aktiftas olahraga, perkembangan kebugaran, sampai cari teman main di aplikasi Wellground",
    bgColor: "#079455",
    phoneMockup: process.env.PUBLIC_URL+'/assets/img/slider/slide-wg.png',
    appStoreUrl: "https://apps.apple.com/id/app/wellground/id6747055551",
    playStoreUrl: "https://play.google.com/store/apps/details?id=com.wellground"
  }
];

export default function HeroSlider() {
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) => 
        prevIndex === slideData.length - 1 ? 0 : prevIndex + 1
      );
    }, 8000);
    return () => clearInterval(timer);
  }, [currentIndex]);

  const [touchStartX, setTouchStartX] = useState(0);
  const [touchEndX, setTouchEndX] = useState(0);

  const handleTouchStart = (e) => {
    setTouchStartX(e.targetTouches[0].clientX);
  };

  const handleTouchMove = (e) => {
    setTouchEndX(e.targetTouches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (!touchStartX || !touchEndX) return;

    const distance = touchStartX - touchEndX;
    const minSwipeDistance = 50; 

    if (distance > minSwipeDistance) {
      setCurrentIndex((prevIndex) => 
        prevIndex === slideData.length - 1 ? 0 : prevIndex + 1
      );
    }

    if (distance < -minSwipeDistance) {
      setCurrentIndex((prevIndex) => 
        prevIndex === 0 ? slideData.length - 1 : prevIndex - 1
      );
    }

    setTouchStartX(0);
    setTouchEndX(0);
  };
  // ---------------------------

  return (
    <div 
      className="hero-slider-wrapper" 
      style={{ backgroundColor: slideData[currentIndex].bgColor }}
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
    >
      <div className="radial-circle circle-1"></div>
      <div className="radial-circle circle-2"></div>
      <div className="radial-circle circle-3"></div>

      <div className="hero-content-container">
        
        {/* SISI KIRI: TEKS, INDIKATOR, & DOWNLOAD BUTTONS */}
        <div className="hero-left-pane">
          <h1 className="hero-main-title">{slideData[currentIndex].title}</h1>
          <p className="hero-sub-description">{slideData[currentIndex].description}</p>
          
          <div className="hero-dots-indicator">
            {slideData.map((_, index) => (
              <div 
                key={index} 
                className={`hero-dot ${currentIndex === index ? 'hero-dot-active' : ''}`}
                onClick={() => setCurrentIndex(index)}
              />
            ))}
          </div>

          <div className="hero-download-area">
            <span className="dl-caption">Download sekarang</span>
            <div className="badge-wrapper">
              <a href={slideData[currentIndex].appStoreUrl} target="_blank" rel="noopener noreferrer">
                <img src={process.env.PUBLIC_URL+'/assets/img/app-store.png'} alt="Download on App Store" className="store-badge-img" />
              </a>
              <a href={slideData[currentIndex].playStoreUrl} target="_blank" rel="noopener noreferrer">
                <img src={process.env.PUBLIC_URL+'/assets/img/google-play.png'} alt="Get it on Google Play" className="store-badge-img" />
              </a>
            </div>
          </div>
        </div>

        {/* SISI KANAN: MOCKUP HP */}
        <div className="hero-right-pane">
          <img 
            src={slideData[currentIndex].phoneMockup} 
            alt="App Mockup" 
            className="hero-showcase-img"
          />
        </div>

      </div>

      <div 
        className="scroll-indicator"
        onClick={() => {
          const nextSection = document.getElementById('stats-section');
          if (nextSection) {
            nextSection.scrollIntoView({ behavior: 'smooth' });
          }
        }}
        style={{
          position: 'absolute',
          bottom: '25px', 
          left: '50%',
          transform: 'translateX(-50%)',
          cursor: 'pointer',
          textAlign: 'center',
          zIndex: 10,
          transition: 'opacity 0.3s'
        }}
      >
        <img 
          src={process.env.REACT_APP_S3+"arrow_down.png"} 
          alt="Scroll Down"
          style={{ width: '45px', height: '45px', objectFit: 'contain' }} 
        />
      </div>

    </div>
  );
}